import Repository from "./repository";

const resource = "/api/v1/price-item";

export default {
  list(request) {
    return Repository.get(`${resource}`, request);
  },
};
